import React from 'react';
import AdminModal from '../AdminModal.js';

const RolesInfoModal = ({ isOpen, onClose, roles }) => (
  <AdminModal
    isOpen={isOpen}
    onClose={onClose}
    title="What are roles?"
    actions={(
      <button className="admin-submit-button" onClick={onClose}>
        Got it
      </button>
    )}
  >
    <p style={{ marginBottom: '20px', color: '#666' }}>
      Roles determine what actions users can perform in the system. Each role has different permissions and abilities.
    </p>
    <div className="roles-info-list">
      {Object.entries(roles)
        .sort(([, a], [, b]) => (a.title || '').localeCompare(b.title || ''))
        .map(([roleId, roleData]) => (
          <div key={roleId} className="role-info-item">
            <div className="role-info-title">{roleData.title || roleId}</div>
            <div className="role-info-description">
              {roleData.description || 'No description available'}
            </div>
          </div>
        ))}
    </div>
  </AdminModal>
);

export default RolesInfoModal;
